import { baseTrack, FontBaseTracker, type BaseTrackPayload } from '@/utils/tracker';

type Payload = Omit<BaseTrackPayload, 'funcId'>;

export const Tracker = {
    ...FontBaseTracker,

    /**
     * 设置图层透明度
     */
    setLayerOpacity(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_21' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 打开片段颜色选择器
     */
    openPieceColorPicker(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_2' };
        baseTrack(basePayload, ['click']);
    },

    /**
     * 设置片段颜色
     */
    setPieceColor(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_2' };
        baseTrack(basePayload, ['use']);
    },

    /**
     * 打开填充颜色选择器
     */
    openFillColorPicker(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_2' };
        baseTrack(basePayload, ['click']);
    },

    /**
     * 设置填充颜色
     */
    setFillColor(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_2' };
        baseTrack(basePayload, ['use']);
    },

    /**
     * 设置模糊
     */
    setBlur(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_52' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 设置圆角
     */
    setRadius(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_162' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 添加描边
     */
    addStroke(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_19' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 移除描边
     */
    removeStroke(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_19' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 打开描边颜色选择器
     */
    openStrokeColorPicker(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_19' };
        baseTrack(basePayload, ['click']);
    },

    /**
     * 更新描边属性
     */
    updateStrokeProps(payload: Payload & { isColor?: boolean }) {
        const { isColor = false, ...rest } = payload;
        const basePayload = { ...rest, funcId: '9_19' };
        const timings: Array<'click' | 'use'> = isColor ? ['use'] : ['click', 'use'];

        baseTrack(basePayload, timings);
    },

    /**
     * 添加阴影
     */
    addShadow(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_106' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 移除阴影
     */
    removeShadow(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_106' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 打开阴影颜色选择器
     */
    openShadowColorPicker(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_106' };
        baseTrack(basePayload, ['click']);
    },

    /**
     * 更新阴影属性
     */
    updateShadowProps(payload: Payload & { isColor?: boolean }) {
        const { isColor = false, ...rest } = payload;
        const basePayload = { ...rest, funcId: '9_106' };
        const timings: Array<'click' | 'use'> = isColor ? ['use'] : ['click', 'use'];

        baseTrack(basePayload, timings);
    },

    /**
     * 添加倒影
     */
    addReflection(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_51' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 添加倒影
     */
    removeReflection(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_51' };
        baseTrack(basePayload, ['click', 'use']);
    },

    /**
     * 更新倒影属性
     */
    updateReflectionProps(payload: Payload) {
        const basePayload = { ...payload, funcId: '9_51' };
        baseTrack(basePayload, ['click', 'use']);
    },
};
